import { render, staticRenderFns } from "./adminn.vue?vue&type=template&id=2ef75396&"
import script from "./adminn.vue?vue&type=script&lang=js&"
export * from "./adminn.vue?vue&type=script&lang=js&"
import style0 from "./adminn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports